"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentLinePathSchema = exports.updateContentLineInput = exports.createContentLineInput = exports.contentLineListSchema = exports.contentLineSchema = exports.notificationTypeSchema = void 0;
/**
 * `RPM-092` — the message-content lines (`rpm_notification_attributes`), maintained on the
 * administration surface (`J-296`).
 *
 * ONE LINE IS ONE THING A MESSAGE MUST CONTAIN, shown to the nurse as a checklist. For each
 * notification type — alert, daily summary, weekly summary — the tenant has default lines (no
 * building) and each building may add its own, in order. An email or text step lists the default
 * alert lines and then the building's (`RPM-070`); a summary lists its kind's lines the same way
 * (`RPM-103`). A line is added, edited, reordered and deactivated, never deleted, and a logged
 * resolution keeps the lines it listed (`RPM-056`).
 *
 * THE POSITION IS THE LINE'S PLACE IN ITS LIST: `ordinal`, unique among the ACTIVE lines of one
 * building (or of the defaults) and one type (`uq_notification_attribute_ordinal`). A second active
 * line at a taken position is `409 CONTENT_LINE_POSITION_TAKEN`. It is a configuration value, not PHI
 * (`03-RPM-SCHEMA.md` §4.2.14), and travels in bodies only.
 */
const zod_1 = require("zod");
const rpm_enums_js_1 = require("./db/rpm-enums.js");
exports.notificationTypeSchema = zod_1.z.enum(rpm_enums_js_1.notificationType.enumValues);
/** `ordinal` is a `smallint`; a position starts at 1. */
const POSITION = zod_1.z.number().int().min(1).max(32767);
/** One line a message must contain. The column is `text`; a line is a sentence, not a page. */
const LINE_TEXT = zod_1.z.string().trim().min(1).max(500);
/** A building's mirror id (`carease.facilities.id`, `varchar(20)`), or null for the tenant's default. */
const APPLIES_TO = zod_1.z.string().min(1).max(20).nullable();
exports.contentLineSchema = zod_1.z.object({
    notificationAttributeId: zod_1.z.uuid(),
    /** Null for the tenant's default line; a building's mirror id for that building's own. */
    facilityId: APPLIES_TO,
    notificationType: exports.notificationTypeSchema,
    attributeText: zod_1.z.string(),
    /** The line's place in its list: the defaults' order, or the building's own order after them. */
    ordinal: POSITION,
    isActive: zod_1.z.boolean(),
    updatedAt: zod_1.z.iso.datetime(),
});
/**
 * The lines this account may read: the tenant's defaults and each building's own it reaches. Per
 * type, the defaults come first, then each building's own, each in position order, active before
 * deactivated.
 */
exports.contentLineListSchema = zod_1.z.object({
    items: zod_1.z.array(exports.contentLineSchema),
});
exports.createContentLineInput = zod_1.z.strictObject({
    facilityId: APPLIES_TO,
    notificationType: exports.notificationTypeSchema,
    attributeText: LINE_TEXT,
    ordinal: POSITION,
});
/** Editing, reordering or deactivating one line. Deactivation is `isActive: false`; nothing deletes one. */
exports.updateContentLineInput = zod_1.z
    .strictObject({
    attributeText: LINE_TEXT.optional(),
    ordinal: POSITION.optional(),
    isActive: zod_1.z.literal(false).optional(),
})
    .refine((v) => Object.keys(v).length > 0, {
    message: "Send at least one field to change.",
});
exports.contentLinePathSchema = zod_1.z.object({ attributeId: zod_1.z.uuid() });
//# sourceMappingURL=rpm-content-lines.js.map